<template>
  <div class="overflow-hidden max-h-full">
    <div
      class="flex justify-between p-4 items-center preview-modal-custom_header"
    >
      <h4 class="m-0 flex-1 text-center">
        {{ lesson.name }}
      </h4>

      <div>
        <button @click="$emit('close')">
          <i class="fal fa-times fa-lg" />
        </button>
      </div>
    </div>

    <div class="preview-modal-custom_body">
      <div class="text-center mt-5">
        <p>
          You are launching a lesson review. This will not update training
          records.
        </p>
      </div>
      <hr />
      <div class="flex justify-between mb-5 mx-5">
        <button class="btn btn-secondary" @click="$emit('close')">
          Cancel
        </button>
        <button class="btn btn-info btn-fill" @click="openLink">
          I understand
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LessonService from "@app/services/lessons";
export default {
  components: {},
  props: {
    lesson: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["close", "click"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    async openLink() {
      this.$emit("close");
      const lesson = await LessonService.preview(this.lesson);
      if (!lesson.preview) {
        this.$notify({
          message: "This lesson is not yet available to review",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
        });
        return;
      }
      return window.open(lesson.preview, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/paper/variables";
.preview-modal-custom {
  &_header {
    background-color: $light-gray;
  }
  &_body {
    max-height: 600px;
  }
  &_item {
    margin: auto 10px;
  }
}
</style>
